/* Sunny Stripes - snow & ice instant quote.
   No price is set in this file. Everything comes from assets/ss-rates.js.

   Snow is the one service NOT priced off lawn area. It is priced per plow, by
   DRIVEWAY size, and the rate card block for it lives in ss-rates.js under
   SNOW - including the seasonPushes figure that decides whether a seasonal
   contract makes money. Read the notes there before changing anything.

   The COMMERCIAL path quotes nothing. It measures the property from satellite
   (assets/ss-measure.js) and books a site walk - see the section below.
*/
(function(){
  "use strict";

  var SS = window.SS_RATES;
  if (!SS) {
    console.error("Sunny Stripes: assets/ss-rates.js did not load - the snow & ice quote tool cannot price anything. Check that the snow page renders it before this file.");
    return;
  }

  /* The shared snow card. Same shape this file always used, one source now. */
  var RATES = SS.snow;

  var KLAVIYO = { publicApiKey:"SKBLA9" };

  var GOOGLE = {
    apiKey: "AIzaSyB8JkZAqLw39qEuj3FKGUsVQ9Yzp5mIAck",
    center: { lat:43.75, lng:-87.75 },   /* Sheboygan County, before we know better */
    bounds: { west:-88.20, south:43.53, east:-87.58, north:43.90 },
    region: "us", state: "WI", county: "sheboygan"
  };

  var TOWNS = ["Adell","Cascade","Cedar Grove","Elkhart Lake","Glenbeulah","Howards Grove",
               "Kohler","Oostburg","Plymouth","Random Lake","Sheboygan","Sheboygan Falls",
               "Waldo","Town of Wilson"];

  var S = {
    /* Per-visit is the DEFAULT on purpose. It is the plan where we are paid for
       every hour we actually work, and it is the cheaper plan in a normal
       winter, so it is also the honest thing to show first. */
    step:1, ptype:"residential", drive:"d2", plan:"push",
    walks:false, saltDrive:false, saltWalks:false,
    outOfArea:false, placeLoc:null
  };

  var $ = function(id){ return document.getElementById(id); };
  var money = function(n){ return "$" + Math.round(n).toLocaleString("en-US"); };
  var esc = function(s){ return String(s == null ? "" : s).replace(/[&<>"]/g, function(c){
    return {"&":"&amp;","<":"&lt;",">":"&gt;","\"":"&quot;"}[c]; }); };
  var isCom = function(){ return S.ptype === "commercial"; };
  function hideErr(id){ var e = $(id); if (e) e.style.display = "none"; }
  function driveBy(k){ return SS.snowDrive(k); }
  function currentDrive(){ return driveBy(S.drive); }

  /* ---------------- the maths ---------------- */
  function quote(){
    var d = currentDrive();
    if (d.custom) return { custom:true };

    var perPush   = SS.snowPerPush(S.drive, S.walks);
    var depthRows = SS.snowDepthRows(S.drive, S.walks);

    /* Seasonal covers plowing and walks for the winter. Salt is never included -
       it is billed per application, because a mild icy winter and a snowy dry one
       need wildly different amounts and nobody should prepay for salt they
       may not need. */
    var season = SS.snowSeason(S.drive, S.walks);

    var saltPer = (S.saltDrive ? RATES.saltDrive : 0) + (S.saltWalks ? RATES.saltWalks : 0);

    return {
      custom:false, d:d,
      perPush: perPush,
      depthRows: depthRows,
      season: season,
      saltPer: saltPer,
      lightWinter: perPush * RATES.seasonLight,
      heavyWinter: perPush * RATES.seasonHeavy,
      breakEven: Math.ceil(season / perPush),
      headline: S.plan === "season" ? season : perPush
    };
  }

  /* ---------------- rendering ---------------- */
  function buildDrives(){
    $("sndrives").innerHTML = RATES.drives.map(function(d){
      var on = (S.drive === d.k);
      return '<div class="lot' + (on ? " sel" : "") + (d.custom ? " custom" : "") + '" data-d="' + d.k + '">' +
             '<span class="tick">✓</span>' +
             '<div class="nm">' + esc(d.nm) + '</div>' +
             '<div class="sz">' + esc(d.sz) + '</div>' +
             '<div class="hint">' + esc(d.hint) + '</div>' +
             '</div>';
    }).join("");
  }

  function render(){
    var q = quote();

    $("snsvcWalks").classList.toggle("on", S.walks);
    $("snsvcSaltD").classList.toggle("on", S.saltDrive);
    $("snsvcSaltW").classList.toggle("on", S.saltWalks);
    $("snplanPush").classList.toggle("on", S.plan === "push");
    $("snplanSeason").classList.toggle("on", S.plan === "season");

    if (q.custom){
      $("snEstHead").textContent = "Custom quote";
      $("snEstArea").textContent = "Extra-long driveway";
      $("snmAmt").innerHTML = "Custom<small>we'll measure it</small>";
      $("snEstItems").innerHTML = '<div class="item"><span class="nm">Extra-long driveway<small>' +
        'Past a certain length the honest answer is that we need to see it. We measure, ' +
        'walk the turnaround, and put a fixed per-push and seasonal number in writing.</small></span></div>';
      $("snEstTotals").style.display = "none";
      $("snCompare").classList.remove("show");
      $("snFlagBig").classList.remove("show");
      return;
    }

    $("snEstHead").textContent = money(q.headline);
    $("snEstArea").textContent = S.plan === "season"
      ? "All winter, " + esc(q.d.nm.toLowerCase()) + " driveway"
      : "Per visit, " + esc(q.d.nm.toLowerCase()) + " driveway";
    $("snmAmt").innerHTML = money(q.headline) +
      "<small>" + (S.plan === "season" ? "all winter" : "per visit") + "</small>";

    var items = "";
    if (S.plan === "season"){
      items += '<div class="item"><span class="nm">Seasonal plowing<small>Every snow of ' +
               RATES.trigger + '" or more, up to ' + RATES.seasonCap + ' visits for the winter' +
               (S.walks ? ", walks and steps included" : "") +
               '. Any depth, same price.</small></span><span class="amt">' + money(q.season) + '</span></div>';
    } else {
      /* One row per depth band. The price steps up with accumulation because
         a deep storm is a slower job, so the customer sees what a bad night
         actually costs before they book rather than on the invoice. */
      items += '<div class="item"><span class="nm">Plowing, per visit<small>' +
               (S.walks ? 'walks and steps included' : 'driveway only') +
               '</small></span><span class="amt">&nbsp;</span></div>';
      q.depthRows.forEach(function(r){
        items += '<div class="item"><span class="nm">' + esc(r.label) + ' of snow<small>' +
                 esc(r.note) + '</small></span><span class="amt">' +
                 (r.price == null ? 'Quote' : money(r.price)) + '</span></div>';
      });
    }
    if (q.saltPer){
      items += '<div class="item"><span class="nm">Salt, per application<small>billed only when we actually salt — never prepaid</small></span><span class="amt">' + money(q.saltPer) + '</span></div>';
    }
    $("snEstItems").innerHTML = items;

    $("snEstTotals").style.display = "block";
    $("snTGrand").textContent = money(q.headline);
    $("snTGrandLbl").textContent = S.plan === "season" ? "Seasonal total" : "Per visit";

  /* The comparison is the whole point of the tool. Show both plans and the
     break-even honestly. We do NOT push seasonal: it fixes the customer's
     price and leaves our labour open-ended, and this business would rather
     be paid per storm than be on call all winter for a flat fee. */
    var cmp = '<div class="cmp-row"><span>Per visit</span><span>' + money(q.perPush) + ' × each plowable snow</span></div>' +
              '<div class="cmp-row"><span>Seasonal</span><span>' + money(q.season) + ' flat, all winter</span></div>' +
              '<div class="cmp-note">A typical winter here brings about <b>' + RATES.seasonPushes +
              '</b> plowable snowfalls, so <b>per visit costs less in most years</b> — about ' +
              money(q.perPush * RATES.seasonPushes) + ' in an average one, ' + money(q.lightWinter) +
              ' in a light winter (' + RATES.seasonLight + ' visits). Seasonal only comes out ahead past the <b>' +
              q.breakEven + 'th</b> visit, which takes a winter worse than most. What it buys is a number that ' +
              'does not move: one price, however much snow falls. Pick per visit if you want to pay for ' +
              'what you get, seasonal if you would rather know the figure in October.</div>';
    $("snCompare").innerHTML = cmp;
    $("snCompare").classList.add("show");

    var big = $("snFlagBig");
    if (S.saltDrive || S.saltWalks){
      big.innerHTML = "Salt is billed per application, never bundled into the seasonal price. " +
                      "Some winters need it a dozen times and some barely at all — you should pay for what you actually get.";
      big.classList.add("show");
    } else {
      big.classList.remove("show");
    }
  }

  /* ======================================================================
     COMMERCIAL: DRAW THE PROPERTY

     A commercial site is rarely one shape - a plaza is a main lot, an overflow
     lot across a drive aisle, a sidewalk run along the storefronts and a rear
     service area. assets/ss-measure.js handles the drawing and the maths for
     any number of disconnected shapes; this section is only the wiring.

     IT MEASURES, IT DOES NOT PRICE. No commercial number is quoted online.
     What we get out of it is an intake good enough to walk the site once.
     ====================================================================== */
  var MEAS = null;

  var SURFACES = [
    { key:"lot",   label:"Parking lot / drive lane", mode:"area",  color:"#E0A500" },
    { key:"walk",  label:"Sidewalk run",             mode:"path",  color:"#4c8a54", width:4 },
    { key:"entry", label:"Entrance / door",          mode:"point", color:"#c0392b", pin:"E" },
    { key:"stack", label:"Room to stack snow",       mode:"point", color:"#2d7ff9", pin:"S" }
  ];

  function measEl(id){ return document.getElementById(id); }

  /* The measuring markup is rendered after the tool snippet, because the tool
     snippet is a 30 KB file and nesting this inside it by hand would risk more
     than one relocation costs. Move it into the commercial step on first use. */
  function relocateMeasure(){
    var node = measEl("sncomMeasure"), host = $("sncomBlock");
    if (!node || !host || node.parentNode === host) return;
    var anchor = host.querySelector(".field");
    if (anchor) host.insertBefore(node, anchor); else host.appendChild(node);
  }

  function initMeasure(){
    if (MEAS && !MEAS.notReady) return;
    if (!window.SS_MEASURE || !SS_MEASURE.ready()) return;   /* maps not up yet */
    var el = measEl("sncomMap");
    if (!el) return;
    /* The commercial block lives in STEP 2, which is display:none while the
       visitor is still on step 1. A Google map built at that moment is 0x0 and
       stays blank forever - it cannot be resized back to life. So do nothing
       here until the step is really on screen; showMeasure() is called again
       from show() the moment it is. */
    if (!el.clientHeight) return;
    MEAS = SS_MEASURE.create({
      mapEl: el,
      center: S.placeLoc || GOOGLE.center,
      zoom: S.placeLoc ? 19 : 14,
      surfaces: SURFACES,
      onChange: renderMeasure,
      onStuck: measureStuck
    });
    if (MEAS.notReady){ MEAS = null; return; }
    buildSurfaceChips();
    renderMeasure();
  }

  function buildSurfaceChips(){
    var box = measEl("sncomSurf");
    if (!box) return;
    box.innerHTML = SURFACES.map(function(sf){
      return '<button type="button" data-surf="' + sf.key + '">' +
             '<span class="dot" style="background:' + sf.color + '"></span>' +
             esc(sf.label) + '</button>';
    }).join("");
  }

  var HINTS = {
    lot:   "Click each corner of the lot, then Finish shape. Draw a separate one for every disconnected area.",
    walk:  "Click along the middle of the sidewalk - we apply the width below. Finish shape when you reach the end.",
    entry: "Click each entrance or door people come through.",
    stack: "Click the corners or islands where snow can be pushed and left."
  };

  /* Google's map sometimes never draws - ss-measure.js explains why, and it is
     not something we can fix from here. When it happens the drawing controls
     are furniture, so clear them away and let the visitor finish the form. The
     lead email already handles an undrawn property; the site walk measures it. */
  function measureStuck(){
    var box = measEl("sncomMeasure");
    if (!box) return;
    ["#sncomSurf", "#sncomHint", ".tools", "#sncomShapes"].forEach(function(sel){
      var el = box.querySelector(sel);
      if (el) el.style.display = "none";
    });
    var tally = measEl("sncomTally");
    if (tally) tally.innerHTML = '<div class="empty">Nothing measured &mdash; ' +
      'we&rsquo;ll take the numbers on the site walk.</div>';
  }

  function renderMeasure(){
    if (!MEAS || MEAS.notReady || MEAS.stuck) return;
    var cur = MEAS.currentSurface();

    var chips = measEl("sncomSurf");
    if (chips) [].forEach.call(chips.querySelectorAll("button"), function(b){
      b.classList.toggle("on", b.dataset.surf === cur);
    });

    /* hint bar */
    var drafting = MEAS.drafting(), pts = MEAS.draftPoints();
    var mode = (SURFACES.filter(function(sf){ return sf.key === cur; })[0] || {}).mode;
    var need = mode === "area" ? 3 : 2;
    var txt = measEl("sncomHintTxt"), fin = measEl("sncomFinish");
    if (txt){
      txt.innerHTML = drafting
        ? (pts >= need
            ? "<b>" + pts + " points</b> - keep clicking, or Finish shape."
            : "<b>" + pts + "</b> of " + need + " points needed.")
        : esc(HINTS[cur] || "Click the map to start.");
    }
    if (fin) fin.disabled = !(drafting && pts >= need);

    /* tally */
    var t = MEAS.totals(), rows = "";
    SURFACES.forEach(function(sf){
      var r = t[sf.key];
      if (!r || !r.count) return;
      var right;
      if (sf.mode === "area") right = r.sqft.toLocaleString("en-US") + " sq ft";
      else if (sf.mode === "path") right = r.feet.toLocaleString("en-US") + " ft";
      else right = r.count + (r.count === 1 ? " spot" : " spots");
      var sub = sf.mode === "point"
        ? ""
        : "<small>" + r.count + (r.count === 1 ? " area" : " areas") +
          (sf.mode === "path" ? " &middot; ~" + r.sqft.toLocaleString("en-US") + " sq ft at " +
             MEAS.widthOf(sf.key) + " ft wide" : "") + "</small>";
      rows += '<div class="row"><span class="nm"><span class="dot" style="background:' + sf.color +
              '"></span><span>' + esc(sf.label) + sub + '</span></span><span class="amt">' + right + '</span></div>';
    });
    var tally = measEl("sncomTally");
    if (tally){
      tally.innerHTML = rows || '<div class="empty">Nothing drawn yet. Pick a surface above and click the map.</div>';
    }

    /* per-shape list, so a mis-drawn area can be removed without starting over */
    var list = measEl("sncomShapes");
    if (list){
      list.innerHTML = MEAS.shapes().map(function(sh, i){
        var sf = SURFACES.filter(function(x){ return x.key === sh.surface; })[0] || {};
        var size = sh.mode === "area" ? sh.sqft.toLocaleString("en-US") + " sq ft"
                 : sh.mode === "path" ? sh.feet.toLocaleString("en-US") + " ft"
                 : "marked";
        return '<div class="shape"><span>' + esc(sf.label || sh.surface) + " #" + (i + 1) +
               ' &middot; ' + size + '</span><button type="button" class="x" data-rm="' + sh.id +
               '" aria-label="Remove">Remove</button></div>';
      }).join("");
    }
  }

  /* Everything the site walk needs, as plain text for the lead email. */
  function measureLines(){
    if (!MEAS || MEAS.notReady || MEAS.isEmpty()) return [];
    return MEAS.summaryLines();
  }

  /* ---------------- property type ---------------- */
  function setPtype(pt){
    S.ptype = pt;
    $("snptRes").classList.toggle("on", pt === "residential");
    $("snptCom").classList.toggle("on", pt === "commercial");
    $("sncomMsg").style.display = isCom() ? "flex" : "none";
    $("sndriveBlock").style.display = isCom() ? "none" : "block";
    $("snresBlock").style.display = isCom() ? "none" : "block";
    $("sncomBlock").style.display = isCom() ? "block" : "none";
    $("snside").style.display = isCom() ? "none" : "";
    $("snmbar").style.display = isCom() ? "none" : "";
    $("snaddr").placeholder = isCom() ? "1000 Highland Dr" : "123 N 8th St";
    if (isCom()){
      relocateMeasure();
      showMeasure();
    } else {
      render();
    }
  }

  /* Build the map if it is buildable now, and lay it out again if it already
     exists and has just come back on screen. Safe to call as often as you like:
     it is the single place that knows the visibility rule. */
  function showMeasure(){
    initMeasure();
    if (MEAS && !MEAS.notReady) MEAS.invalidate(S.placeLoc, S.placeLoc ? 19 : null);
  }

  /* ---------------- steps ---------------- */
  function show(n){
    if (n === 2 && !validate(1)) return;
    if (n === 3 && !validate(1)) { n = 1; }
    S.step = n;
    ["sp1","sp2","sp3"].forEach(function(id,i){ $(id).style.display = (i+1===n) ? "block" : "none"; });
    $("spDone").style.display = "none";
    var sts = $("snsteps").children;
    for (var i=0;i<sts.length;i++){
      sts[i].classList.toggle("active", i+1===n);
      sts[i].classList.toggle("done", i+1<n);
    }
    $("snfill").style.width = (n/3*100) + "%";
    /* Step 2 holds the commercial map, and this is the first moment it has a
       size to be built at. See initMeasure() for why that is not optional. */
    if (n === 2 && isCom()){ relocateMeasure(); showMeasure(); }
    $("snmBtn").textContent = n===1 ? "Choose my plan →" : (n===2 ? "Get my quote →" : "Send my request →");
    var t = $("sntool");
    if (t) window.scrollTo({ top: t.offsetTop - 20, behavior:"smooth" });
  }

  function validate(n){
    if (n === 1){
      var bad = [], addr = $("snaddr"), city = $("sncity");
      [addr, city].forEach(function(el){
        var empty = !el.value.trim();
        el.classList.toggle("bad", empty);
        if (empty) bad.push(el);
      });
      var e = $("sne1");
      if (S.outOfArea){
        addr.classList.add("bad");
        e.style.display = "block";
        e.textContent = "That address is outside Sheboygan County — we can't get a truck there on a snow night. " +
                        "Call us at (920) 943-6422 if you think that's wrong.";
        return false;
      }
      e.style.display = bad.length ? "block" : "none";
      e.textContent = "Add your street address and city so we can check you're on a route we plow.";
      if (bad.length) bad[0].focus();
      return !bad.length;
    }
    if (n === 3){
      var need = ["snfname","snemail","snphone"], miss = [];
      need.forEach(function(id){
        var el = $(id), empty = !el.value.trim();
        el.classList.toggle("bad", empty);
        if (empty) miss.push(el);
      });
      var em = $("snemail");
      if (em.value.trim() && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())){ em.classList.add("bad"); miss.push(em); }
      var e3 = $("sne3");
      e3.style.display = miss.length ? "block" : "none";
      e3.textContent = "We need a name, a working email and a phone number — on a snow night the phone is how we reach you.";
      if (miss.length) miss[0].focus();
      return !miss.length;
    }
    return true;
  }

  /* ---------------- address autocomplete ---------------- */
  var AC = { ready:false, lib:null, token:null, sug:[], active:-1, timer:null };
  var PIN = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>';

  function buildTowns(){
    var sel = $("sncity");
    if (!sel) return;
    sel.innerHTML = '<option value="">Select…</option>' +
      TOWNS.map(function(t){ return '<option>' + t + '</option>'; }).join("") +
      '<option value="other">Other Sheboygan County town</option>';
  }

  function loadMaps(){
    if (window.google && window.google.maps && window.google.maps.importLibrary) return initAC();
    if (document.getElementById("sn-gmaps")) return;
    window.__snGmaps = initAC;
    var sc = document.createElement("script");
    sc.id = "sn-gmaps"; sc.async = true;
    sc.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(GOOGLE.apiKey) +
             "&libraries=places,geometry&v=weekly&callback=__snGmaps";
    sc.onerror = function(){ AC.ready = false; };
    document.head.appendChild(sc);
  }
  function initAC(){
    try{
      google.maps.importLibrary("places").then(function(lib){
        AC.lib = lib; AC.ready = !!(lib && lib.AutocompleteSuggestion);
      })["catch"](function(){ AC.ready = false; });
      /* Maps arrives asynchronously. If the visitor already switched to the
         commercial path while it was loading, bring the map up now. */
      google.maps.importLibrary("geometry").then(function(){
        if (isCom()) showMeasure();
      })["catch"](function(){});
    }catch(e){ AC.ready = false; }
  }
  function acClose(){
    var b = $("snaddrSuggest");
    b.classList.remove("open"); b.innerHTML = "";
    AC.sug = []; AC.active = -1;
  }
  function acFetch(q){
    if (!AC.ready || q.length < 3) return acClose();
    try{
      if (!AC.token && AC.lib.AutocompleteSessionToken) AC.token = new AC.lib.AutocompleteSessionToken();
      AC.lib.AutocompleteSuggestion.fetchAutocompleteSuggestions({
        input: q, sessionToken: AC.token || undefined,
        includedRegionCodes: [GOOGLE.region],
        locationRestriction: GOOGLE.bounds
      }).then(function(res){ AC.sug = (res && res.suggestions) || []; acRender(); })
        ["catch"](function(){ acClose(); });
    }catch(e){ acClose(); }
  }
  function acRender(){
    var box = $("snaddrSuggest"), html = "", n = 0;
    AC.sug.forEach(function(s,i){
      var p = s.placePrediction; if (!p) return;
      var main = (p.mainText && p.mainText.text) || (p.text && p.text.text) || "";
      var sub  = (p.secondaryText && p.secondaryText.text) || "";
      html += '<div class="as-item" data-i="'+i+'" role="option">' + PIN +
              '<span><span class="as-main">'+esc(main)+'</span> <span class="as-sub">'+esc(sub)+'</span></span></div>';
      n++;
    });
    if (!n) return acClose();
    html += '<div class="as-foot">Powered by Google</div>';
    box.innerHTML = html; box.classList.add("open"); AC.active = -1;
  }
  function acMove(d){
    var items = $("snaddrSuggest").querySelectorAll(".as-item");
    if (!items.length) return;
    AC.active = (AC.active + d + items.length) % items.length;
    for (var i=0;i<items.length;i++) items[i].classList.toggle("active", i===AC.active);
  }
  function acChoose(i){
    var s = AC.sug[i]; if (!s || !s.placePrediction) return;
    var p = s.placePrediction;
    try{
      var place = p.toPlace();
      place.fetchFields({ fields:["addressComponents","formattedAddress","location"] }).then(function(){ acFill(place); })
        ["catch"](function(){ $("snaddr").value = (p.text && p.text.text) || $("snaddr").value; });
    }catch(e){ $("snaddr").value = (p.text && p.text.text) || $("snaddr").value; }
    AC.token = null; acClose();
  }
  function acFill(place){
    var c = place.addressComponents || [];
    function get(t, short){
      for (var i=0;i<c.length;i++){
        var types = c[i].types || [];
        if (types.indexOf(t) >= 0) return (short ? c[i].shortText : c[i].longText) || c[i].longText || "";
      }
      return "";
    }
    var street = ((get("street_number") ? get("street_number") + " " : "") + get("route")).trim();
    $("snaddr").value = street || place.formattedAddress || $("snaddr").value;
    $("snaddr").classList.remove("bad");
    var city = get("locality") || get("sublocality") || get("administrative_area_level_3");
    var state = get("administrative_area_level_1", true);
    var county = get("administrative_area_level_2");
    var zip = get("postal_code");
    if (zip) $("snzip").value = zip;
    /* Drop the measuring map on the property they just picked, so a commercial
       visitor is looking at their own roof instead of hunting for it. */
    if (place.location){
      S.placeLoc = { lat: place.location.lat(), lng: place.location.lng() };
      if (MEAS && !MEAS.notReady) MEAS.recenter(S.placeLoc, 19);
    }

    var sel = $("sncity"), matched = false;
    if (city){
      for (var i=0;i<sel.options.length;i++){
        if (sel.options[i].text.toLowerCase() === city.toLowerCase()){ sel.selectedIndex = i; matched = true; break; }
      }
      if (!matched) sel.value = "other";
      sel.classList.remove("bad");
    }

    var msg = $("snareaMsg");
    msg.style.display = "block";
    var outOfState  = state  && state !== GOOGLE.state;
    var outOfCounty = county && county.toLowerCase().indexOf(GOOGLE.county) < 0;
    if (outOfState || outOfCounty){
      S.outOfArea = true;
      msg.innerHTML = "That address is outside Sheboygan County — we can't get a truck there on a snow night. " +
                      "Call us at (920) 943-6422 if you think that's wrong.";
      sel.classList.add("bad");
      return;
    }
    S.outOfArea = false;
    msg.innerHTML = "✓ " + esc(city || "That address") + " is in Sheboygan County — we plow the whole county.";
    hideErr("sne1");
  }

  /* ---------------- lead delivery ---------------- */
  function ssPostForm(id, fields){
    var f = document.getElementById(id);
    if (!f) return false;
    Object.keys(fields).forEach(function(k){
      var el = f.querySelector('[name="' + k + '"]');
      if (el) el.value = fields[k];
    });
    try{
      if (window.Shopify && Shopify.captcha && Shopify.captcha.protect){
        Shopify.captcha.protect(f, function(){ try{ f.submit(); }catch(e){} });
        return true;
      }
    }catch(e){}
    var b = f.querySelector('[type="submit"]');
    if (b){ b.click(); return true; }
    if (f.requestSubmit){ f.requestSubmit(); return true; }
    f.submit();
    return true;
  }
  function ssPhoneE164(p){
    var d = String(p || "").replace(/\D/g, "");
    if (d.length === 10) return "+1" + d;
    if (d.length === 11 && d.charAt(0) === "1") return "+" + d;
    return null;
  }
  function ssKlaviyo(metricName, p){
    if (!KLAVIYO.publicApiKey) return;
    try{
      var prof = { email: p.email, first_name: p.first_name, last_name: p.last_name };
      var e164 = ssPhoneE164(p.phone_number);
      if (e164) prof.phone_number = e164;
      fetch("https://a.klaviyo.com/client/events/?company_id=" + encodeURIComponent(KLAVIYO.publicApiKey), {
        method:"POST",
        headers:{ "Content-Type":"application/json", "revision":"2024-10-15" },
        body: JSON.stringify({ data:{ type:"event", attributes:{
          metric:{ data:{ type:"metric", attributes:{ name: metricName } } },
          properties: p,
          profile:{ data:{ type:"profile", attributes: prof } }
        } } })
      })["catch"](function(){});
    }catch(e){}
  }
  function pad(label){ return (label + " ").padEnd ? (label + " ").padEnd(28, ".") : label + " ......"; }
  /* Depth labels carry an inch mark. Plain email and Klaviyo properties read
     better with the word, so swap it once here rather than at each call site. */
  function inches(label){ return String(label).split('"').join("in"); }
  function leadSummary(p, q){
    var L = [];
    L.push("SNOW & ICE REQUEST — " + p.reference);
    L.push("");
    L.push("Name:      " + (p.first_name + " " + p.last_name).trim());
    L.push("Email:     " + p.email);
    L.push("Phone:     " + p.phone_number);
    L.push("Property:  " + p.address + ", " + p.city + " " + p.zip);
    L.push("Type:      " + (p.property_type === "commercial" ? "COMMERCIAL" : "Residential"));
    L.push("");
    if (p.property_type === "commercial"){
      L.push("COMMERCIAL INTAKE — needs a site walk, no price quoted online.");
      L.push("  " + pad("Property type") + " " + (p.com_type || "-"));
      L.push("  " + pad("Clear-by time") + " " + (p.com_hours || "-"));
      L.push("  " + pad("Salt required") + " " + (p.com_salt || "-"));
      L.push("  " + pad("Current provider") + " " + (p.com_current || "-"));
      if (p.com_size)  L.push("  " + pad("Lot size, in words") + " " + p.com_size);
      if (p.com_walks) L.push("  " + pad("Walks / entrances") + " " + p.com_walks);
      /* The measured property is the reason this intake is worth having. */
      if (p.com_measured && p.com_measured.length){
        L.push("");
        L.push("MEASURED FROM SATELLITE — drawn by the customer");
        p.com_measured.forEach(function(line){ L.push("  " + line); });
        L.push("");
        L.push(p.com_nostack
          ? "  *** NOWHERE TO STACK SNOW — they say the lot has no room. Hauling job. ***"
          : "  Stacking: see the marked spots above.");
      } else {
        L.push("");
        L.push("  (They did not draw the property — measure it on the walk.)");
      }
    } else {
      L.push("Driveway:  " + p.drive_name + " (" + p.drive_size + ")");
      L.push("Walks:     " + (p.walks ? "yes" : "no"));
      L.push("Plan:      " + (p.plan === "season" ? "SEASONAL" : "Per push"));
      L.push("Salt:      " + (p.salt_drive || p.salt_walks
              ? ((p.salt_drive ? "driveway" : "") + (p.salt_drive && p.salt_walks ? " + " : "") + (p.salt_walks ? "walks" : ""))
              : "none requested"));
      L.push("");
      if (p.quoted_custom){
        L.push("ESTIMATE:  Custom — extra-long driveway, needs measuring.");
      } else {
        L.push("ESTIMATE");
        q.depthRows.forEach(function(r){
          L.push("  " + pad("Per visit, " + inches(r.label)) + " " +
                 (r.price == null ? "quote on the day" : money(r.price)));
        });
        L.push("  " + pad("Seasonal, all winter") + " " + money(q.season));
        if (q.saltPer) L.push("  " + pad("Salt per application") + " " + money(q.saltPer));
        L.push("  " + pad("THEY CHOSE") + " " + (p.plan === "season" ? money(q.season) + " seasonal" : money(q.perPush) + " per visit"));
      }
    }
    if (p.notes){ L.push(""); L.push("Notes: " + p.notes); }
    L.push("");
    L.push("Marketing opt-in: " + (p.optin ? "yes" : "no"));
    L.push("Submitted from the snow & ice page.");
    return L.join("\n");
  }
  function sendLead(p, q){
    if (!/^https?:$/.test(location.protocol)){
      console.log("(preview mode — lead not sent)\n" + leadSummary(p, q));
      return;
    }
    try{
      var tags = "Snow Lead" + (p.property_type === "commercial" ? ", Commercial" : "");
      if (p.optin){
        ssPostForm("ssCustomerForm", {
          "contact[first_name]": p.first_name,
          "contact[last_name]":  p.last_name,
          "contact[email]":      p.email,
          "contact[tags]":       tags
        });
      }
      ssPostForm("ssLeadForm", {
        "contact[name]":  (p.first_name + " " + p.last_name).trim(),
        "contact[email]": p.email,
        "contact[phone]": p.phone_number,
        "contact[body]":  leadSummary(p, q)
      });
    }catch(e){}
  }

  /* ---------------- events ---------------- */
  document.addEventListener("click", function(ev){
    var t = ev.target;
    if (!t || !t.closest) return;

    var as = t.closest("#snaddrSuggest .as-item");
    if (as){ acChoose(parseInt(as.dataset.i,10)); return; }
    if (!t.closest("#snaddrField")) acClose();

    var pt = t.closest("#snptype button");
    if (pt){ setPtype(pt.dataset.pt); return; }

    var lot = t.closest("#sndrives .lot");
    if (lot){ S.drive = lot.dataset.d; buildDrives(); render(); return; }

    /* The plan buttons wrap <span> children, so the click target is usually the
       span, not the button. Match on the ancestor carrying data-plan. */
    var plan = t.closest("[data-plan]");
    if (plan){ S.plan = plan.dataset.plan; render(); return; }

    var svc = t.closest(".svc[data-svc]");
    if (svc){
      var k = svc.dataset.svc;
      if (k === "walks")   S.walks = !S.walks;
      if (k === "saltd")   S.saltDrive = !S.saltDrive;
      if (k === "saltw")   S.saltWalks = !S.saltWalks;
      render(); return;
    }

    /* --- measuring controls (commercial only) --- */
    var surfBtn = t.closest("#sncomSurf button[data-surf]");
    if (surfBtn){ if (MEAS) MEAS.setSurface(surfBtn.dataset.surf); return; }
    if (t.id === "sncomFinish"){ if (MEAS) MEAS.finish(); return; }
    if (t.id === "sncomUndo"){   if (MEAS) MEAS.undo();   return; }
    if (t.id === "sncomClear"){  if (MEAS) MEAS.clear();  return; }
    var rm = t.closest("[data-rm]");
    if (rm){ if (MEAS) MEAS.remove(rm.dataset.rm); return; }

    var go = t.closest("[data-go]");
    if (go){ show(parseInt(go.dataset.go,10)); return; }

    var st = t.closest("#snsteps .st");
    if (st){ show(parseInt(st.dataset.s,10)); return; }

    if (t.id === "snmBtn"){ show(Math.min(3, S.step+1)); return; }
  });

  $("snaddr").addEventListener("input", function(){
    S.outOfArea = false;
    var q = this.value.trim();
    clearTimeout(AC.timer);
    AC.timer = setTimeout(function(){ acFetch(q); }, 180);
  });
  $("snaddr").addEventListener("keydown", function(ev){
    if (!$("snaddrSuggest").classList.contains("open")) return;
    if (ev.key === "ArrowDown"){ ev.preventDefault(); acMove(1); }
    else if (ev.key === "ArrowUp"){ ev.preventDefault(); acMove(-1); }
    else if (ev.key === "Enter" && AC.active >= 0){ ev.preventDefault(); acChoose(AC.active); }
    else if (ev.key === "Escape"){ acClose(); }
  });

  function watch(ids, errId){
    ids.forEach(function(id){
      var el = $(id); if (!el) return;
      ["input","change"].forEach(function(evt){
        el.addEventListener(evt, function(){ this.classList.remove("bad"); hideErr(errId); });
      });
    });
  }
  (function(){
    var w = document.getElementById("sncomWalkW");
    if (!w) return;
    w.addEventListener("input", function(){
      var v = parseFloat(this.value);
      if (MEAS && v > 0) MEAS.setWidth("walk", v);
    });
  })();

  watch(["snaddr","sncity","snzip"], "sne1");
  watch(["snfname","snlname","snemail","snphone"], "sne3");

  /* ---------------- submit ---------------- */
  $("snsubmit").addEventListener("click", function(){
    if (!validate(3)) return;
    var q = quote(), d = currentDrive();
    var ref = "SN-" + String(Math.floor(Math.random()*9000)+1000);
    var payload = {
      first_name: $("snfname").value.trim(),
      last_name:  $("snlname").value.trim(),
      email:      $("snemail").value.trim(),
      phone_number: $("snphone").value.trim(),
      address:    $("snaddr").value.trim(),
      city:       $("sncity").value,
      zip:        $("snzip").value.trim(),
      notes:      $("snnotes").value.trim(),
      optin:      $("snoptin").checked,
      property_type: S.ptype,
      reference:  ref,
      source:     "snow-ice-quote"
    };

    if (isCom()){
      payload.com_type    = $("sncomType").value;
      payload.com_size    = $("sncomSize").value.trim();
      payload.com_walks   = $("sncomWalks").value.trim();
      payload.com_hours   = $("sncomHours").value;
      payload.com_salt    = $("sncomSalt").value;
      payload.com_current = $("sncomCurrent").value.trim();
      payload.com_measured = measureLines();
      payload.com_nostack  = !!(measEl("sncomNoStack") && measEl("sncomNoStack").checked);
      if (MEAS && !MEAS.notReady){
        var mt = MEAS.totals();
        payload.com_lot_sqft   = mt.lot   ? mt.lot.sqft   : 0;
        payload.com_lot_areas  = mt.lot   ? mt.lot.count  : 0;
        payload.com_walk_ft    = mt.walk  ? mt.walk.feet  : 0;
        payload.com_walk_sqft  = mt.walk  ? mt.walk.sqft  : 0;
        payload.com_walk_runs  = mt.walk  ? mt.walk.count : 0;
        payload.com_entries    = mt.entry ? mt.entry.count : 0;
        payload.com_stackspots = mt.stack ? mt.stack.count : 0;
      }
    } else {
      payload.drive_key   = d.k;
      payload.drive_name  = d.nm;
      payload.drive_size  = d.sz;
      payload.walks       = S.walks;
      payload.plan        = S.plan;
      payload.salt_drive  = S.saltDrive;
      payload.salt_walks  = S.saltWalks;
      payload.quoted_custom = !!q.custom;
      if (!q.custom){
        payload.quoted_per_push = q.perPush;
        payload.quoted_depth_bands = q.depthRows.map(function(r){
          return inches(r.label) + " " + (r.price == null ? "quote" : "$" + r.price);
        }).join(", ");
        payload.quoted_season   = q.season;
        payload.quoted_salt     = q.saltPer;
        payload.quoted_total    = q.headline;
      }
    }

    sendLead(payload, q);
    ssKlaviyo("Snow Quote Requested", payload);

    if (window.dataLayer) window.dataLayer.push({
      event:"snow_quote_request", value:payload.quoted_total || null, reference:ref, property_type:S.ptype
    });

    $("sndoneName").textContent = payload.first_name || "friend";
    $("sndoneRef").textContent = "Reference " + ref;
    var recap = '<div class="item"><span>' + esc(payload.address) + ", " + esc(payload.city) + '</span><span class="amt">' +
                (isCom() ? "Commercial" : esc(d.nm)) + '</span></div>';
    if (isCom()){
      if (payload.com_lot_sqft){
        recap += '<div class="item"><span>Lot drawn</span><span class="amt">' +
                 payload.com_lot_sqft.toLocaleString("en-US") + " sq ft · " +
                 payload.com_lot_areas + (payload.com_lot_areas === 1 ? " area" : " areas") + '</span></div>';
      }
      if (payload.com_walk_ft){
        recap += '<div class="item"><span>Walks drawn</span><span class="amt">' +
                 payload.com_walk_ft.toLocaleString("en-US") + " ft · " +
                 payload.com_walk_runs + (payload.com_walk_runs === 1 ? " run" : " runs") + '</span></div>';
      }
      recap += '<div class="item"><span><b>Next step</b></span><span class="amt">Site walk</span></div>';
    } else if (q.custom){
      recap += '<div class="item"><span><b>Estimate</b></span><span class="amt">We\'ll measure it</span></div>';
    } else {
      recap += '<div class="item"><span>Plan</span><span class="amt">' + (S.plan === "season" ? "Seasonal" : "Per visit") + '</span></div>';
      recap += '<div class="item"><span><b>Estimate</b></span><span class="amt">' + money(q.headline) + '</span></div>';
      if (q.saltPer) recap += '<div class="item"><span>Salt, per application</span><span class="amt">' + money(q.saltPer) + '</span></div>';
    }
    $("sndoneRecap").innerHTML = recap;

    ["sp1","sp2","sp3"].forEach(function(id){ $(id).style.display = "none"; });
    $("spDone").style.display = "block";
    var sts = $("snsteps").children;
    for (var i=0;i<sts.length;i++){ sts[i].classList.add("done"); sts[i].classList.remove("active"); }
    $("snfill").style.width = "100%";
    $("snmbar").style.display = "none";
    celebrate();
    var el = $("sntool");
    if (el) window.scrollTo({ top: el.offsetTop - 20, behavior:"smooth" });
  });

  function celebrate(){
    try{
      if (window.matchMedia && matchMedia("(prefers-reduced-motion:reduce)").matches) return;
      var box = $("snconfetti");
      if (!box){
        box = document.createElement("div");
        box.id = "snconfetti"; box.setAttribute("aria-hidden","true");
        box.style.cssText = "position:fixed;inset:0;pointer-events:none;z-index:5;overflow:hidden";
        document.body.appendChild(box);
      }
      var colors = ["#235029","#4c8a54","#7bbd82","#E0A500","#183a1e"];
      for (var i=0;i<70;i++){
        (function(i){
          var c = document.createElement("i");
          c.style.cssText = "position:absolute;top:-12px;width:9px;height:14px;opacity:.9;" +
            "animation:snfall linear forwards;left:" + (Math.random()*100) + "vw;" +
            "background:" + colors[i % colors.length] + ";" +
            "animation-duration:" + (2.4 + Math.random()*1.8) + "s;" +
            "animation-delay:" + (Math.random()*0.5) + "s;" +
            "transform:rotate(" + (Math.random()*360) + "deg)";
          box.appendChild(c);
          setTimeout(function(){ if (c.parentNode) c.parentNode.removeChild(c); }, 4600);
        })(i);
      }
      if (!document.getElementById("snfall-kf")){
        var st = document.createElement("style");
        st.id = "snfall-kf";
        st.textContent = "@keyframes snfall{to{transform:translateY(105vh) rotate(680deg);opacity:.9}}";
        document.head.appendChild(st);
      }
    }catch(e){}
  }

  buildTowns();
  buildDrives();
  /* Move the measuring block into the (hidden) commercial step before anything
     is shown, so it is never briefly visible sitting under the tool. */
  relocateMeasure();
  setPtype("residential");
  $("snfill").style.width = "33%";
  loadMaps();
})();
